import { useEffect, useState } from 'react';
import AuthHeader from './AuthHeader';
import AuthForm from './AuthForm';
import usePostData from 'hooks/usePostData';

import translating from './../translate.json';

const VerificationForm = () => {
  const { res, error, postData } = usePostData();
  const [errFun, setErrFun] = useState();

  let mobile = sessionStorage.getItem('mobileMvmt');
  if (mobile && mobile != 'undefined' && mobile.length === 10)
    mobile = `${mobile.slice(6)}******`;
  else mobile = null;

  let code;

  useEffect(() => {
    if (error)
      errFun?.set('apiError', {
        type: 'string',
        message: error.apiError
      });
    else if (res && res.user_name) {
      window.location.href = '/';
    }
  }, [res, error]);

  const handleSubmit = (data, setError) => {
    setErrFun({ set: setError });
    const deepData = { ...data };
    deepData.otp = Number(data.otp);
    deepData.sessionId = sessionStorage.getItem('sessionMvmt');
    postData('auth/OTP/Verify', deepData);
  };

  const sendAgainOPT = () => {
    const session = sessionStorage.getItem('sessionMvmt');
    postData('auth/OTP/ReSendOtp', { sesseion: session });
  };

  const fields = [
    {
      name: 'otp',
      label: translating.codeLabel,
      errMsg: translating.verificationCodeNotValid,
      defaultValue: code
    }
  ];

  return (
    <div className="verification-form">
      <AuthHeader
        title={`${translating.codeTitle} ${mobile ? mobile : ''}`}
        description={translating.codeDescription}
      ></AuthHeader>
      <AuthForm
        fields={fields}
        link={{
          text: translating.forgotEmailSendAgain,
          handleClickLink: sendAgainOPT
        }}
        submitTxt={translating.submitLabel}
        handleClickSubmit={handleSubmit}
      ></AuthForm>
    </div>
  );
};

export default VerificationForm;
